import axios from "axios";
import { getToken } from "../utils/getToken";

const axiosInstance = axios.create({
  baseURL: "https://prospuh2learn.com/api/v1/admin",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken("adminLogin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
